/**
 * PlanPriceBlock — Süperadmin merchant açma / plan değiştirme kartlarının
 * paylaştığı fiyat satırı.
 *
 * Davranış:
 *   - Trial (price_try=0): "Ücretsiz"
 *   - Aylık / Yıllık: KDV hariç büyük + KDV dahil küçük
 *   - 2 Yıllık (discount_pct>0): üstü çizili list (hem +KDV hem dahil) +
 *     altında indirimli final (hem +KDV hem dahil) + "%X indirim" rozeti
 */
import { formatTRY, computePlanPrices } from "./_tenant-helpers";

export default function PlanPriceBlock({ plan, testId }) {
    const price = Number(plan?.price_try || 0);
    if (price === 0) {
        return (
            <div data-testid={testId} className="space-y-0.5">
                <div className="font-display text-base font-semibold tracking-tight">Ücretsiz</div>
            </div>
        );
    }
    const { listExVAT, listInclVAT, finalExVAT, finalInclVAT, hasDiscount, discountPct } = computePlanPrices(plan);
    if (!hasDiscount) {
        return (
            <div data-testid={testId} className="space-y-0.5">
                <div className="font-display text-base font-semibold tracking-tight leading-tight">
                    {formatTRY(listExVAT)}
                    <span className="text-[10px] font-medium text-muted-foreground ml-1 align-middle">+KDV</span>
                </div>
                <div className="text-[11px] text-muted-foreground">
                    {formatTRY(listInclVAT)} <span className="text-[10px]">KDV dahil</span>
                </div>
            </div>
        );
    }
    // 2 Yıllık / indirimli plan
    return (
        <div data-testid={testId} className="space-y-0.5">
            <div className="flex items-baseline gap-1.5 flex-wrap">
                <span className="text-[11px] text-muted-foreground line-through">
                    {formatTRY(listExVAT)} <span className="text-[10px]">+KDV</span>
                </span>
                <span className="inline-flex items-center rounded-sm bg-emerald-100 text-emerald-800 border border-emerald-200 px-1 text-[9px] font-semibold tracking-wide uppercase">
                    %{discountPct} indirim
                </span>
            </div>
            <div className="text-[11px] text-muted-foreground line-through -mt-0.5">
                {formatTRY(listInclVAT)} <span className="text-[10px]">KDV dahil</span>
            </div>
            <div className="font-display text-base font-semibold tracking-tight leading-tight mt-1 text-emerald-700">
                {formatTRY(finalExVAT)}
                <span className="text-[10px] font-medium text-muted-foreground ml-1 align-middle">+KDV</span>
            </div>
            <div className="text-[11px] text-muted-foreground">
                {formatTRY(finalInclVAT)} <span className="text-[10px]">KDV dahil</span>
            </div>
        </div>
    );
}
